// extracted by mini-css-extract-plugin
export default {"main":"AuditLogsBody_main__6ai92"};